import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Table } from '@/components/atoms/Table';
import { Title } from '@/components/atoms/Title';
import { Text } from '@/components/atoms/Text';
import RawModal from '@/components/atoms/RawModal';
import Loader from '@/components/atoms/Loader';
import { SvyButton } from '@/components/savory/SvyButton';
import { HeaderLeft, HeaderRight, Subtitle } from '@/components/atoms/Section/Section.style';
import RouterNavigationTabs from '@/components/organisms/RouterNavigationTabs';
import { routes } from '@/core/router/routes';
import { useRestaurantTabRoutes } from '../hooks/useRestaurantTabRoutes';
import { usePickupPointTableVM } from './PickupPoint.viewmodel';
import { Container, Header, HeaderContainer } from './PickupPoints.style';
import { PickupPointModal } from './components/PickupPointModal/PickupPointModal';

const PickupPoint: React.FunctionComponent<React.PropsWithChildren> = () => {
    const {
        headers,
        rows,
        action: { type, name, pickupPointId, address, additionalAddressInfo },
        brandId,
        restaurantId,
        isLoading,
        handleRowClick,
        clearAction,
        toggleCreateModal,
    } = usePickupPointTableVM();

    const restaurantTabRoutes = useRestaurantTabRoutes();
    const tabRoutes = React.useMemo(
        () => (restaurantId ? restaurantTabRoutes : routes.filter(({ tab }) => tab === 'brands')),
        [restaurantId, restaurantTabRoutes],
    );

    return (
        <RouterNavigationTabs routes={tabRoutes}>
            <PickupPointModal
                action={type}
                onHide={clearAction}
                brandId={brandId}
                restaurantId={restaurantId}
                pickupPointId={pickupPointId}
                name={name}
                address={address}
                additionalAddressInfo={additionalAddressInfo}
                isOpen={type === 'showCreateModal' || type === 'showEditModal' || type === 'showDeleteModal'}
            />
            <Container>
                <HeaderContainer>
                    <Header>
                        <HeaderLeft>
                            <Title text="pickupPoint.page.title" />
                            <Subtitle>
                                <Text text="pickupPoint.page.description" />
                            </Subtitle>
                        </HeaderLeft>
                        <HeaderRight>
                            {true && (
                                <SvyButton onClick={toggleCreateModal} size="s">
                                    <FormattedMessage id="pickupPoint.action.create" />
                                </SvyButton>
                            )}
                        </HeaderRight>
                    </Header>
                    <Table
                        isSearchable
                        rows={rows}
                        emptyMessageId="table.noRowsAfterFilter"
                        columns={headers}
                        hasUrlNavigation
                        isSortable
                        isLoading={isLoading}
                        onRowClick={handleRowClick}
                    />
                </HeaderContainer>
            </Container>
        </RouterNavigationTabs>
    );
};

export default PickupPoint;
